import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=3c46c38e&scoped=true&"
import script from "./IconPlus.vue?vue&type=script&lang=js&"
export * from "./IconPlus.vue?vue&type=script&lang=js&"
import style0 from "./IconPlus.vue?vue&type=style&index=0&id=3c46c38e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46c38e",
  null
  
)

export default component.exports